// extracted by mini-css-extract-plugin
export var details = "_kz-0";
export var inspectorPopover = "_kz-1";